import { Icon, Text, TextInput, XStack } from '@frontend/web-react';
import { safeCss } from '@frontend/web-utils';

type TaskChatSearchBarProps = {
  currentMatchIndex: number;
  onClose: () => void;
  onGoToNext: () => void;
  onGoToPrev: () => void;
  onSearchChange: (query: string) => void;
  searchQuery: string;
  totalMatches: number;
};

export const TaskChatSearchBar = ({
  currentMatchIndex,
  onClose,
  onGoToNext,
  onGoToPrev,
  onSearchChange,
  searchQuery,
  totalMatches,
}: TaskChatSearchBarProps) => {
  return (
    <XStack alignItems="center" borderBottom borderColor="neutral200" className="bg-trueWhite" gap="sm" px="md" py="sm">
      <Icon className="text-neutral-500" name="IconSearch" size="md" />
      <TextInput
        accessibilityLabel="Search messages"
        autoFocus
        classNames={{
          input: safeCss('h-[36px] border-none focus-within:border-none'),
          root: safeCss('flex-1'),
        }}
        onChange={onSearchChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (e.shiftKey) {
              onGoToPrev();
            } else {
              onGoToNext();
            }
          }
        }}
        placeholder="Search messages..."
        value={searchQuery}
      />
      {searchQuery.trim() ? (
        <XStack alignItems="center" gap="xs">
          <Text className="whitespace-nowrap text-neutral-500" type="p-sm">
            {totalMatches > 0 ? `${currentMatchIndex + 1} of ${totalMatches}` : 'No results'}
          </Text>
          <Icon
            className="cursor-pointer text-neutral-600 hover:text-neutral-900"
            name="IconChevronUp"
            onClick={onGoToPrev}
            size="md"
          />
          <Icon
            className="cursor-pointer text-neutral-600 hover:text-neutral-900"
            name="IconChevronDown"
            onClick={onGoToNext}
            size="md"
          />
        </XStack>
      ) : null}
      <Icon
        className="cursor-pointer text-neutral-500 hover:text-neutral-900"
        name="IconX"
        onClick={onClose}
        size="md"
      />
    </XStack>
  );
};
